import { ApolloCache } from '@apollo/client/core';
import {
  AiCodeSuggestionDefaultFragment,
  MemoDefaultFragmentDoc,
  SourceDefaultFragmentDoc,
  GroupContentsFragmentDoc,
  AiCodeSuggestionDefaultFragmentDoc,
  SourceDefaultFragment,
  MemoDefaultFragment,
} from '@/graphql/operations.gen';

export const updateMemoInCache = (
  store: ApolloCache<any>,
  { id }: { id: string },
  updateFn: (data: MemoDefaultFragment) => Partial<MemoDefaultFragment>
) => {
  const cacheId = `Memo:${id}`;

  return store.updateFragment<MemoDefaultFragment>(
    {
      fragment: MemoDefaultFragmentDoc,
      fragmentName: 'MemoDefault',
      id: cacheId,
    },
    (data) => ({ ...data, ...updateFn(data) })
  );
};

export const updateSourceInCache = (
  store: ApolloCache<any>,
  { id }: { id: string },
  updateFn: (data: SourceDefaultFragment) => Partial<SourceDefaultFragment>
) => {
  const cacheId = `Source:${id}`;

  return store.updateFragment<SourceDefaultFragment>(
    {
      fragment: SourceDefaultFragmentDoc,
      fragmentName: 'SourceDefault',
      id: cacheId,
    },
    (data) => ({ ...data, ...updateFn(data) })
  );
};

export const updateGroupContentsInCache = (apolloCache: ApolloCache<any>, id: string, updateFn: (data) => any) => {
  apolloCache.updateFragment(
    {
      id: `Group:${id}`,
      fragment: GroupContentsFragmentDoc,
      fragmentName: 'GroupContents',
    },
    (data) => ({ ...data, ...updateFn(data) })
  );
};

/**
 * Updates ai code suggestions, but only if they exist
 */
export const updateAiCodeSuggestionInCache = (
  cache: ApolloCache<any>,
  { id },
  newData: {
    id: string;
    name: string;
    color: string;
    comment: string;
    parent?: { id: string };
  }
) => {
  cache.updateFragment<AiCodeSuggestionDefaultFragment>(
    {
      id: `AiCodeSuggestion:${id}`,
      fragment: AiCodeSuggestionDefaultFragmentDoc,
      fragmentName: 'AiCodeSuggestionDefault',
    },
    (data) => {
      if (!data) {
        return data;
      }

      return {
        __typename: 'AiCodeSuggestion',
        id: newData.id,
        name: newData.name,
        color: newData.color,
        occurrence: 0,
        isNewCode: false,
        comment: newData.comment,
        parent: newData.parent || data.parent,
      };
    }
  );
};
